import { useEffect } from 'react';

export default function useClickOutside(
  refs: React.RefObject<HTMLElement>[],
  handler: () => void,
  when: boolean = true,
) {
  useEffect(() => {
    if (!when) return;

    const listener = (event: MouseEvent) => {
      if (refs.some((ref) => ref.current?.contains(event.target as Node))) {
        return;
      }
      handler();
    };

    document.addEventListener('mousedown', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [refs, handler, when]);
}
